import React, { useEffect, useState } from "react";
import SearchableSelect from "../../../../components/searchableSelect/SearchableSelect";
import api from "../../../../services/axios";
import { getTasks, getWorkedByTask } from "../../../../services/projectTaskApi";
import { ProjectTask } from "../../../../interfaces/ProjectTask";
import CapacityBudgetVsActual from "./CapacityBudgetVsActual";

/**
 * Orçado × Realizado — árvore de horas estimadas contra apontadas.
 *
 * Este painel voltou da tela inicial para cá. Ele é uma ferramenta de **drill-down**: carrega TODAS
 * as tarefas da empresa e todo o realizado por tarefa, o que é caro demais para a primeira tela de
 * todo login. Aqui, atrás de uma aba, o custo só é pago por quem realmente vai investigar.
 *
 * A busca acontece no mount deste componente, ou seja, só quando a aba é aberta.
 */
const BudgetVsActualPanel: React.FC<{ namesById: Map<number, string> }> = ({ namesById }) => {
  const [tasks, setTasks] = useState<ProjectTask[]>([]);
  const [workedByTask, setWorkedByTask] = useState<Record<number, number>>({});
  const [clients, setClients] = useState<{ id: number; name: string }[]>([]);
  const [clientNameByProject, setClientNameByProject] = useState<Record<number, string>>({});
  const [clientFilter, setClientFilter] = useState<string>("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/Project/Projects")
      .then((r) => {
        const list = (Array.isArray(r.data) ? r.data : []).filter(
          (p: any) => p.status == null || p.status === 1
        );
        const byProj: Record<number, string> = {};
        const clientMap = new Map<number, string>();
        list.forEach((p: any) => {
          if (p.clientName) byProj[p.id] = p.clientName;
          if (p.clientId != null) clientMap.set(p.clientId, p.clientName ?? `Cliente #${p.clientId}`);
        });
        setClientNameByProject(byProj);
        setClients(Array.from(clientMap, ([id, name]) => ({ id, name })));
      })
      .catch((e) => console.error("Erro ao carregar projetos", e));
  }, []);

  useEffect(() => {
    const clientId = clientFilter === "all" ? undefined : Number(clientFilter);
    setLoading(true);
    Promise.all([
      getTasks(clientId).then(setTasks),
      getWorkedByTask(clientId).then((rows) => {
        const m: Record<number, number> = {};
        rows.forEach((r) => (m[r.taskId] = r.workedHours));
        setWorkedByTask(m);
      }),
    ])
      .catch((e) => console.error("Erro ao carregar orçado × realizado", e))
      .finally(() => setLoading(false));
  }, [clientFilter]);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex w-full flex-col gap-1.5 sm:max-w-xs">
        <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">Cliente</label>
        <SearchableSelect
          value={clientFilter}
          onChange={(v) => setClientFilter(v ? String(v) : "all")}
          options={[
            { label: "Todos os clientes", value: "all" },
            ...clients.map((c) => ({ label: c.name, value: String(c.id) })),
          ]}
        />
      </div>

      {loading ? (
        <div className="py-10 text-center text-sm text-gray-700 dark:text-gray-300">Carregando...</div>
      ) : (
        <CapacityBudgetVsActual
          tasks={tasks}
          workedByTask={workedByTask}
          clientNameByProject={clientNameByProject}
          namesById={namesById}
          selectedEmpIds={[]}
        />
      )}
    </div>
  );
};

export default BudgetVsActualPanel;
